// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================= MAIN Container ================= */
.creds-container {
  width: 80%;
  margin: 0 auto;
  padding: 10px;
  background:
    radial-gradient(circle at top left, rgba(139, 92, 246, 0.18), transparent 35%),
    radial-gradient(circle at bottom right, rgba(59, 130, 246, 0.16), transparent 40%),
    #050816;
  color: #e2e8f0;
}

/* ================= HEADER ================= */
.creds-header-card {
    background: #0f172a;
    width: 40%;
    margin: auto;
    padding: 20px;
    border-radius: 12px;
    border: 1px solid #1e293b;
    text-align: center;
}

/* ================= BUTTONS ================= */
.creds-actions { display: flex; gap: 10px; }
.creds-btn {
    border: none;
    padding: 8px 16px;
    border-radius: 6px;
    cursor: pointer;
    color: white;
    font-weight: 600;
    transition: 0.2s;
}

.creds-btn.info { background: #64748b; }
.creds-btn.edit { background: #3b82f6; }
.creds-btn.login { background: #10b981; }
.creds-btn.delete { background:#f87171; }

/* ================= LIST & ITEM ================= */
.creds-list { list-style: none; padding: 0; }

.creds-item {
    background: #0f172a;
    margin-bottom: 12px;
    border-radius: 10px;
    border: 1px solid #1e293b;
    padding: 15px 25px;
    transition: 0.3s;
}

.creds-item-main {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

/* ================= DETAILS ================= */
.creds-details-box {
  padding: 18px;
  border-top: 1px solid rgba(255,255,255,0.06);
  background: rgba(2,6,23,0.4);
}

.creds-details-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.creds-detail-card {
  padding: 12px;
  border-radius: 12px;
  background: rgba(255,255,255,0.04);
  border: 1px solid rgba(255,255,255,0.06);
}

.creds-detail-card span {
  display: block;
  font-size: 0.75rem;
  color: #94a3b8;
}

.creds-detail-card strong {
  color: #fff;
}

.creds-detail-card.full {
  grid-column: span 2;
}

/* ================= MODAL ================= */

.creds-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.7);
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
  z-index: 9999;
}

.creds-modal {
  width: 100%;
  max-width: 780px;
  max-height: 90vh;
  overflow-y: auto;
  background: rgba(15, 23, 42, 0.95);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 20px;
  padding: 16px;
  box-shadow: 0 25px 80px rgba(0,0,0,0.6);
}

.creds-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.creds-modal-header h3 {
  margin: 0;
  font-size: 1.3rem;
  color: #fff;
}

.creds-modal-close {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(255,255,255,0.08);
  border: none;
  color: #fff;
  cursor: pointer;
  transition: 0.2s;
}

.creds-modal-close:hover {
  background: rgba(239,68,68,0.2);
  color: #f87171;
}

/* ================= FORM (shared style) ================= */

.cpop-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.cpop-input-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.cpop-input-group label {
  font-size: 0.85rem;
  color: #cbd5e1;
}

.cpop-input-group input,
.cpop-input-group select,
.cpop-input-group textarea {
  padding: 12px 14px;
  border-radius: 12px;
  background: rgba(30, 41, 59, 0.8);
  border: 1px solid rgba(255,255,255,0.08);
  color: #fff;
  outline: none;
}

.cpop-input-group input:focus,
.cpop-input-group select:focus,
.cpop-input-group textarea:focus {
  border-color: #7c3aed;
  box-shadow: 0 0 0 3px rgba(124,58,237,0.2);
}

.cpop-grid-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.cpop-button-group {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
}

.cpop-btn-submit {
  background: linear-gradient(135deg, #7c3aed, #2563eb);
  color: #fff;
  border: none;
  padding: 10px 16px;
  border-radius: 12px;
  cursor: pointer;
}

.cpop-btn-cancel {
  background: rgba(255,255,255,0.08);
  color: #cbd5e1;
  border: none;
  padding: 10px 16px;
  border-radius: 12px;
  cursor: pointer;
}

/* ================= RESPONSIVE ================= */
@media (max-width: 768px) {
    .creds-container { width: 95%; }
    .creds-header-card { width: 100%; }
    .creds-item-main { flex-direction: column; align-items: flex-start; gap: 15px; }
    .creds-actions { width: 100%; display: grid; grid-template-columns: 1fr 1fr; }
}`, "",{"version":3,"sources":["webpack://./src/components/InfoManage/Credentials.css"],"names":[],"mappings":"AAAA,uDAAuD;AACvD;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb;;;WAGS;EACT,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;IACI,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA,gDAAgD;AAChD,iBAAiB,aAAa,EAAE,SAAS,EAAE;AAC3C;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,kBAAkB,mBAAmB,EAAE;AACvC,kBAAkB,mBAAmB,EAAE;AACvC,mBAAmB,mBAAmB,EAAE;AACxC,oBAAoB,kBAAkB,EAAE;;AAExC,oDAAoD;AACpD,cAAc,gBAAgB,EAAE,UAAU,EAAE;;AAE5C;IACI,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,4CAA4C;EAC5C,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8CAA8C;;AAE9C;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA,4DAA4D;;AAE5D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;EAGE,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,wCAAwC;EACxC,WAAW;EACX,aAAa;AACf;;AAEA;;;EAGE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,mDAAmD;AACnD;IACI,mBAAmB,UAAU,EAAE;IAC/B,qBAAqB,WAAW,EAAE;IAClC,mBAAmB,sBAAsB,EAAE,uBAAuB,EAAE,SAAS,EAAE;IAC/E,iBAAiB,WAAW,EAAE,aAAa,EAAE,8BAA8B,EAAE;AACjF","sourcesContent":["/* ================= MAIN Container ================= */\n.creds-container {\n  width: 80%;\n  margin: 0 auto;\n  padding: 10px;\n  background:\n    radial-gradient(circle at top left, rgba(139, 92, 246, 0.18), transparent 35%),\n    radial-gradient(circle at bottom right, rgba(59, 130, 246, 0.16), transparent 40%),\n    #050816;\n  color: #e2e8f0;\n}\n\n/* ================= HEADER ================= */\n.creds-header-card {\n    background: #0f172a;\n    width: 40%;\n    margin: auto;\n    padding: 20px;\n    border-radius: 12px;\n    border: 1px solid #1e293b;\n    text-align: center;\n}\n\n/* ================= BUTTONS ================= */\n.creds-actions { display: flex; gap: 10px; }\n.creds-btn {\n    border: none;\n    padding: 8px 16px;\n    border-radius: 6px;\n    cursor: pointer;\n    color: white;\n    font-weight: 600;\n    transition: 0.2s;\n}\n\n.creds-btn.info { background: #64748b; }\n.creds-btn.edit { background: #3b82f6; }\n.creds-btn.login { background: #10b981; }\n.creds-btn.delete { background:#f87171; }\n\n/* ================= LIST & ITEM ================= */\n.creds-list { list-style: none; padding: 0; }\n\n.creds-item {\n    background: #0f172a;\n    margin-bottom: 12px;\n    border-radius: 10px;\n    border: 1px solid #1e293b;\n    padding: 15px 25px;\n    transition: 0.3s;\n}\n\n.creds-item-main {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n/* ================= DETAILS ================= */\n.creds-details-box {\n  padding: 18px;\n  border-top: 1px solid rgba(255,255,255,0.06);\n  background: rgba(2,6,23,0.4);\n}\n\n.creds-details-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n}\n\n.creds-detail-card {\n  padding: 12px;\n  border-radius: 12px;\n  background: rgba(255,255,255,0.04);\n  border: 1px solid rgba(255,255,255,0.06);\n}\n\n.creds-detail-card span {\n  display: block;\n  font-size: 0.75rem;\n  color: #94a3b8;\n}\n\n.creds-detail-card strong {\n  color: #fff;\n}\n\n.creds-detail-card.full {\n  grid-column: span 2;\n}\n\n/* ================= MODAL ================= */\n\n.creds-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.7);\n  backdrop-filter: blur(10px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 12px;\n  z-index: 9999;\n}\n\n.creds-modal {\n  width: 100%;\n  max-width: 780px;\n  max-height: 90vh;\n  overflow-y: auto;\n  background: rgba(15, 23, 42, 0.95);\n  border: 1px solid rgba(255,255,255,0.08);\n  border-radius: 20px;\n  padding: 16px;\n  box-shadow: 0 25px 80px rgba(0,0,0,0.6);\n}\n\n.creds-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.creds-modal-header h3 {\n  margin: 0;\n  font-size: 1.3rem;\n  color: #fff;\n}\n\n.creds-modal-close {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  background: rgba(255,255,255,0.08);\n  border: none;\n  color: #fff;\n  cursor: pointer;\n  transition: 0.2s;\n}\n\n.creds-modal-close:hover {\n  background: rgba(239,68,68,0.2);\n  color: #f87171;\n}\n\n/* ================= FORM (shared style) ================= */\n\n.cpop-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.cpop-input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.cpop-input-group label {\n  font-size: 0.85rem;\n  color: #cbd5e1;\n}\n\n.cpop-input-group input,\n.cpop-input-group select,\n.cpop-input-group textarea {\n  padding: 12px 14px;\n  border-radius: 12px;\n  background: rgba(30, 41, 59, 0.8);\n  border: 1px solid rgba(255,255,255,0.08);\n  color: #fff;\n  outline: none;\n}\n\n.cpop-input-group input:focus,\n.cpop-input-group select:focus,\n.cpop-input-group textarea:focus {\n  border-color: #7c3aed;\n  box-shadow: 0 0 0 3px rgba(124,58,237,0.2);\n}\n\n.cpop-grid-row {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n}\n\n.cpop-button-group {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.cpop-btn-submit {\n  background: linear-gradient(135deg, #7c3aed, #2563eb);\n  color: #fff;\n  border: none;\n  padding: 10px 16px;\n  border-radius: 12px;\n  cursor: pointer;\n}\n\n.cpop-btn-cancel {\n  background: rgba(255,255,255,0.08);\n  color: #cbd5e1;\n  border: none;\n  padding: 10px 16px;\n  border-radius: 12px;\n  cursor: pointer;\n}\n\n/* ================= RESPONSIVE ================= */\n@media (max-width: 768px) {\n    .creds-container { width: 95%; }\n    .creds-header-card { width: 100%; }\n    .creds-item-main { flex-direction: column; align-items: flex-start; gap: 15px; }\n    .creds-actions { width: 100%; display: grid; grid-template-columns: 1fr 1fr; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
